// frontend/packages/business-console/src/services/aiUsageService.js
//
// Thin wrapper over GET /api/v2/ai-usage — month-to-date AI/API spend
// for the active business (spend vs the 7.6 cap, reset date, AI token
// tally, per-api breakdown). Business context comes from the
// x-business-id header (axios interceptor); callers don't pass it.

import { api } from '@upryzze/services';

/**
 * @returns {Promise<{
 *   configured: boolean,
 *   capUsd: number,
 *   spendUsd: number,
 *   pctOfCap: number,
 *   overSoft: boolean,
 *   overHard: boolean,
 *   softThresholdPct: number,
 *   periodStart: string,   // ISO
 *   resetsAt: string,      // ISO — 1st of next month UTC
 *   aiTokens: number,
 *   bySurface: Array<{ key: string, costUsd: number }>,
 * }>}
 */
export async function getAiUsage() {
  const { data } = await api.get('/v2/ai-usage');
  return data;
}
